// Copyright ©️ 2026 eVolve MEP, LLC

import { type Project, useEvolvePaginatedGet } from '@evolvemep/api-ts';

import {
  SearchableSelect,
  type SearchableSelectProps,
} from 'components/Mantine/TypeSafeSelect/PaginatedSelectors/SearchableSelect';
import { CreateProjectModal } from 'modules/Admin/Projects/CreateProjectModal';

export type Props = Omit<
  SearchableSelectProps<'shop/project', Project, 'projectId'>,
  'idKey' | 'paginatedGet' | 'getItemLabel' | 'value' | 'onChange'
> & {
  value?: Project | null;
  onChange: (project: Project | null) => void;
};

export const ProjectSelect = ({ placeholder = 'Select a project...', ...props }: Props) => {
  const paginatedProject = useEvolvePaginatedGet('shop/project');

  return (
    <SearchableSelect<'shop/project', Project, 'projectId'>
      idKey="projectId"
      paginatedGet={paginatedProject}
      getItemLabel={(f) => f.projectName}
      placeholder={placeholder}
      createLabel="Create new project"
      creationModal={(startingValue, modalProps) => (
        <CreateProjectModal
          editing={false}
          opened={modalProps.opened}
          onClose={modalProps.onClose}
          initialProjectName={startingValue}
          onProjectCreated={(project) => {
            props.onChange(project);
            modalProps.onClose();
          }}
        />
      )}
      {...props}
    />
  );
};
